import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { InvoiceModel, Patient } from '@mmx/shared'

interface CollectPaymentDialogData {
  invoice: InvoiceModel
  patient: Patient
}

@Component({
  selector: 'mmx-collect-payment-dialog',
  templateUrl: './collect-payment-dialog.component.html',
  standalone: false,
})
export class CollectPaymentDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CollectPaymentDialogData,
    public dialogRef: MatDialogRef<CollectPaymentDialogComponent>,
  ) {}
}
